import { PureComponent } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { Paper, PaperProps, Typography } from '@mui/material';

interface Props extends PaperProps {
    loading?: boolean;
    // sx?: React.CSSProperties;
    elevation?: number;
    message?: string;
}
export default class LoadingPaper extends PureComponent<Props> {
    render() {
        const { children, elevation, loading, message, ...rest } = this.props;
        if (loading) {
            return (
                <div style={{ textAlign: 'center', padding: '5rem' }}>
                    <CircularProgress />
                    {message ? <Typography variant="h6">{message}</Typography> : null}
                </div>
            );
        } else {
            return (
                <Paper elevation={elevation ? elevation : 0} {...rest}>
                    {children}
                </Paper>
            );
        }
    }
}
